import React from 'react';

const Home = () => <><div className="row">
    <div className="col-md-2 col-xs-12"></div>
    <div className="col-md-8 col-xs-12">
        <p><b>Description :</b> I developed this movie browser using React Js and getting data from OMDB Api.</p>
    </div>
    <div className="col-md-2 col-xs-12"></div>
</div>
<footer className="row footer">
    <div className="col-md-4">
        
        
    </div>
        <div className="col-md-4"><p>Movie Browser App</p></div>
    <div className="col-md-4">
        
        </div>
</footer></>;

export default Home;